<template>
  <div class="animated fadeIn">
    <div class="mb-10">
      <a @click="openPage('/memberEntry/edit?id=' + id_member + '&page=' + previousCurrentPage)" class="link-back">
        <i class="fas fa-arrow-circle-left mr-5"></i>Back
      </a>
    </div>
    <div class="row justify-content-center mb-5">
      <div class="col-md-6">
        <div class="card shadow-sm border-0 text-center">
          <div class="card-body py-4">
            <h5 class="card-title text-muted">Total Point</h5>
            <h1 class="display-4 fw-bold text-primary">{{ totalPoint }}</h1>
            <p class="text-success">equals IDR {{ totalPoint }}</p>

            <div class="d-flex justify-content-end">
              <span>Expired at <b>{{ pointsExpiredDate }}</b></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- History Tab -->
    <div class="box">
      <b-tabs content-class="mt-3">
        <!-- History TAB -->
        <b-tab title="History" id="info_1_tab" active>
          <div class="p-15 pb-0">
            <div class="row">

              <!-- <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div> -->
            </div>


            <div class="row">
              <div class="font-bold mb-10 col-sm-6">Point History</div>
              <div class="col-sm-6 text-right">
                <a v-if="!isViewOnly" @click="openAdjustMemberPoint()" class="font-bold color-primary mb-10">+
                  Adjust</a>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15 pt-0">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
              :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
              <!--          <template slot="thumbnail" slot-scope="data">-->
              <template v-slot:cell(thumbnail)="data">
                <b-btn @click="showModal('coach' + data.item.id)" size="sm" class="btn-table green"><i
                    class="fas fa-eye mr-5"></i>View</b-btn>
                <b-modal modal-class="modal-custom-image" hide-footer :ref="'coach' + data.item.id" centered
                  title="Personal Training">
                  <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
                </b-modal>
              </template>
              <!--          <template slot="status" slot-scope="data">-->
              <template v-slot:cell(status)="data">
                <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
              </template>
              <template v-slot:cell(is_facerecognition)="data">
                <template>
                  <b-badge v-if="data.item.is_facerecognition == 1" :variant="'success'">Yes</b-badge>
                  <b-badge v-if="data.item.is_facerecognition == 0" :variant="'info'">No</b-badge>
                </template>
              </template>
              <!--          <template slot="actions" slot-scope="data">-->
              <!-- <template v-slot:cell(actions)="data">
            <b-button size="sm" @click="editCoach('/coach/edit?id=' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button size="sm" v-on:click="deleteCoach(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template> -->
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
              @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
          </div>
        </b-tab>

        <!-- Information TAB -->

        <b-tab title="Detail Information" id="info_1_tab">
          <div class="row">
            <div class="col-md-12">
              <div class="font-bold col-sm-6">PT Session Information</div>
              <div class="justify-content-end col-sm-12" style="display: grid;">
                <strong>Current Session Cut: {{ itemsPtSessionRunning.length }}/10</strong>
                <strong>Left day: {{ memberInfoData.pt_session_left_day ? memberInfoData.pt_session_left_day :
                  '-'}}</strong>
              </div>
              <div class="p-15 pb-0">
                <table class="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Tanggal</th>
                      <th>Trx ID</th>
                      <th>PT Name</th>
                      <th>Member Name</th>
                      <th>PT Session</th>
                      <th>Price per session</th>
                      <th>Source</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in itemsPtSessionRunning" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.running_date }}</td>
                      <td>{{ item.trx_id }}</td>
                      <td>{{ item.pt_name }}</td>
                      <td>{{ item.member_name }}</td>
                      <td>{{ item.pt_session_name }}</td>
                      <td>{{ item.pt_session_price }}</td>
                      <td>{{ item.source }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="p-15 pb-0">
                <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
                  :small="small" :fixed="fixed" responsive="sm" :items="itemsPtSession" :fields="fieldsPtSession"
                  :current-page="currentPage">
                  <template v-slot:cell(action)="data">
                    <b-btn size="sm" class="btn-table green" @click="detailPtSession(data.item)"><i
                        class="fas fa-eye mr-5"></i>Detail</b-btn>
                  </template>
                </b-table>
              </div>
            </div>

            <hr class="border">

            <div class="col-md-12">
              <div class="font-bold col-sm-6">PT Session Information (ALPHA)</div>
              <div class="justify-content-end col-sm-12" style="display: grid;">
                <strong>Current Session Cut: {{ itemsPtSessionRunningAlpha.length }}/10</strong>
                <strong>Left day: {{ memberInfoData.pt_session_alpha_left_day}}</strong>
              </div>
              <div class="p-15 pb-0">
                <table class="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Tanggal</th>
                      <th>Trx ID</th>
                      <th>PT Name</th>
                      <th>Member Name</th>
                      <th>PT Session</th>
                      <th>Price per session</th>
                      <th>Source</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in itemsPtSessionRunningAlpha" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.running_date }}</td>
                      <td>{{ item.trx_id }}</td>
                      <td>{{ item.pt_name }}</td>
                      <td>{{ item.member_name }}</td>
                      <td>{{ item.pt_session_name }}</td>
                      <td>{{ item.pt_session_price }}</td>
                      <td>{{ item.source }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="p-15 pb-0">
                <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
                  :small="small" :fixed="fixed" responsive="sm" :items="itemsPtSessionAlpha" :fields="fieldsPtSession"
                  :current-page="currentPage">
                  <template v-slot:cell(action)="data">
                    <b-btn size="sm" class="btn-table green" @click="detailPtSessionAlpha(data.item)"><i
                        class="fas fa-eye mr-5"></i>Detail</b-btn>
                  </template>
                </b-table>
              </div>
            </div>

            <hr class="border">

            <!-- CheckIn Information -->
            <div class="col-md-12">
              <div class="font-bold col-sm-6">Check-In Information</div>
              <div class="justify-content-end col-sm-12" style="display: grid;">
                <strong>Current Check In: {{ detailItemsCheckIn.length }}/20</strong>
                <strong>Current Month: {{ currentMonth }}</strong>
              </div>
              <div class="p-15 pb-0">
                <table class="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Tanggal</th>
                      <th>Member Name</th>
                      <th>Branch</th>
                      <th>Point</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in detailItemsCheckIn" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.point_date }}</td>
                      <td>{{ item.member_name }}</td>
                      <td>{{ item.branch_name }}</td>
                      <td>{{ formatCurrency(item.total_point) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="p-15 pb-0">
                <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
                  :small="small" :fixed="fixed" responsive="sm" :items="itemCheckIn" :fields="fieldsCheckIn"
                  :current-page="currentPage">
                  <template v-slot:cell(action)="data">
                    <b-btn size="sm" class="btn-table green" @click="detailCheckIn(data.item)"><i
                        class="fas fa-eye mr-5"></i>Detail</b-btn>
                  </template>
                </b-table>
              </div>
            </div>

            <hr class="border">

            <!-- AutoPay Information -->
            <div class="col-md-12">
              <div class="font-bold col-sm-6">Autopay Information</div>
              <div class="p-15 pb-0">
                <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
                  :small="small" :fixed="fixed" responsive="sm" :items="itemAutoPay" :fields="fieldsAutoPay"
                  :current-page="currentPage">
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <!-- modal -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'adjust_member_point'" title="Adjust Point">
      <div class="p-10">
        <form @submit.prevent="onSavePoint()">
          <b-row>
            <b-col md="6" class="mb-3">
              <label for="sales_id">Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="dataPoint.adjust_type" class="form-control border-bottom">
                  <option value="null" selected>Please select</option>
                  <option value="1">Add</option>
                  <option value="2">Deduct</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="6" class="mb-3">
              <label for="sales_id">Total Amount</label>
              <div class="mb-10">
                <input type="number" name="point" v-model="dataPoint.adjust_point" class="form-control border-bottom"
                  placeholder="Amount" />
              </div>
            </b-col>

            <b-col md="12" class="mb-3">
              <label for="sales_id">Branch</label>
              <div class="mb-10">
                <b-form-select @change="changeBranch(event)" name="sales_id" v-model="branch_id"
                  class="form-control border-bottom">
                  <option value="null" selected>Please select</option>
                  <option v-for="branch in dataBranch" :key="branch.id" :value="branch.id">
                    {{ branch.name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>

            <!-- sales -->
            <b-col md="12" class="mb-3">
              <label for="sales_id">Customer Service</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="dataPoint.sales_id" class="form-control border-bottom">
                  <option value="null" selected>Please select</option>
                  <option v-for="sales in listSales" :key="sales.id" :value="sales.id">
                    {{ sales.name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>

            <b-col md="12" class="mb-3">
              <label for="sales_id">Notes</label>
              <div class="mb-10">
                <!-- reason -->
                <textarea placeholder="Notes" name="reason" v-model="dataPoint.reason" class="form-control w-100"
                  id="reason"></textarea>
              </div>
            </b-col>
          </b-row>
          <div class="mt-5 text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- modal detail pt session -->
    <b-modal modal-class="modal-custom-image" size="xl" hide-footer :ref="'detail_pt_session'"
      title="Detail PT Session">
      <div class="p-10">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Trx ID</th>
              <th>PT Name</th>
              <th>Member Name</th>
              <th>PT Session</th>
              <th>Price per session</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in detailItemsPtSession" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.tgl }}</td>
              <td>{{ item.trx_id }}</td>
              <td>{{ item.pt_name }}</td>
              <td>{{ item.member_name }}</td>
              <td>{{ item.pt_session_name }}</td>
              <td>{{ formatCurrency(item.price_per_session) }}</td>
              <td>{{ item.source }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- modal detail pt session alpha -->
    <b-modal modal-class="modal-custom-image" size="xl" hide-footer :ref="'detail_pt_session_alpha'"
      title="Detail PT Session Alpha">
      <div class="p-10">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Trx ID</th>
              <th>PT Name</th>
              <th>Member Name</th>
              <th>PT Session</th>
              <th>Price per session</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in detailItemsPtSessionAlpha" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.tgl }}</td>
              <td>{{ item.trx_id }}</td>
              <td>{{ item.pt_name }}</td>
              <td>{{ item.member_name }}</td>
              <td>{{ item.pt_session_name }}</td>
              <td>{{ formatCurrency(item.price_per_session) }}</td>
              <td>{{ item.source }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>


    <!-- modal detail checkIn -->
    <b-modal modal-class="modal-custom-image" size="xl" hide-footer :ref="'detail_check_in'" title="Detail Check In">
      <div class="p-10">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Member Name</th>
              <th>Branch</th>
              <th>Point</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in detailItemsCheckIn" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.point_date }}</td>
              <td>{{ item.member_name }}</td>
              <td>{{ item.branch_name }}</td>
              <td>{{ formatCurrency(item.total_point) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'
import { is } from 'core-js/core/object'

export default {
  name: 'coach',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      currentMonth: moment().format('MMM-YYYY'),
      fields: [
        {
          key: 'type',
          label: 'Type',
          sortable: true
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: true,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.amount).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        },
        {
          key: 'notes',
          label: 'Description',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Date',
          sortable: true,
          formatter: (value, key, item) => {
            return moment(item.created_at).format('YYYY/MM/DD HH:mm:ss')
          }
        },
        {
          key: 'point_idr',
          label: 'Point IDR',
          sortable: false
        },
        {
          key: 'running_balance',
          label: 'Balance',
          sortable: false,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.running_balance).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        },
        {
          key: 'direction',
          label: 'Notes',
          sortable: false
        }
      ],
      fieldsPtSession: [
        {
          key: 'point_date',
          label: 'Tanggal',
          sortable: false
        },
        {
          key: 'total_amount',
          label: 'Amount',
          sortable: false,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.total_amount).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        },
        {
          key: 'total_point',
          label: 'Total Point',
          sortable: true,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.total_point).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false
        }
      ],
      fieldsCheckIn: [
        {
          key: 'point_date',
          label: 'Tanggal',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'total_point',
          label: 'Total Point',
          sortable: false,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.total_point).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        },
        {
          key: 'total_checkin',
          label: 'Total Check-In',
          sortable: false
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false
        }
      ],
      fieldsAutoPay: [
        {
          key: 'point_date',
          label: 'Tanggal',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'total_point',
          label: 'Total Point',
          sortable: false,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.total_point).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          }
        }
      ],
      items: [],
      itemsPtSession: [],
      itemsPtSessionAlpha: [],
      itemsPtSessionRunning: [],
      itemsPtSessionRunningAlpha: [],
      detailItemsPtSession: [],
      detailItemsPtSessionAlpha: [],
      detailItemsCheckIn: [],
      memberInfoData: {},
      itemAutoPay: [],
      itemCheckIn: [],
      dataBranch: [],
      branch_id: null,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      totalPoint: '0',
      totalEquals: '0',
      pointsExpiredDate: '',
      previousCurrentPage: 1,
      dataPoint: {
        trx_id: '',
        adjust_type: "1",
        adjust_point: 0,
        reason: '',
        sales_id: null
      },
      id_member: 0,
      listSales: [],
      isViewOnly: false,
      dataInfoPoint: {}
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    generateCode(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    formatCurrency(value) {
      return 'Rp. ' + parseFloat(value).toLocaleString('id-ID', { maximumFractionDigits: 2 })
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    changeBranch(event) {
      this.dataPoint.sales_id = null
      axios.get('crm/v1/customer_service?status=active&sorting=name&sorting_type=asc&branch_id=' + this.branch_id).then(response => {
        this.listSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    editCoach(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    openAdjustMemberPoint() {
      this.showModal("adjust_member_point")
    },
    detailPtSession(item) {
      this.showModal("detail_pt_session")
      console.log('PT Session', item)

      this.loadingActive = true
      // testing
      axios.get('crm/v1/member_point_info/pt_session_detail?member_id=' + this.$route.query.id + '&point_id=' + item.id).then(response => {
        console.log("Info Point: ", response.data.data)
        var info = response.data.data
        this.detailItemsPtSession = info
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    detailPtSessionAlpha(item) {
      this.showModal("detail_pt_session_alpha")
      console.log('PT Session', item)

      this.loadingActive = true
      // testing
      axios.get('crm/v1/member_point_info/pt_session_running_alpha?member_id=' + this.$route.query.id + '&point_id=' + item.id).then(response => {
        console.log("Info Point: ", response.data.data)
        var info = response.data.data
        this.detailItemsPtSessionAlpha = info
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    detailCheckIn(item) {
      this.showModal("detail_check_in")
      this.loadingActive = true
      // testing
      axios.get('crm/v1/member_point_info/daily_checkin_detail?member_id=' + this.$route.query.id + '&date=' + moment(item.created_at).format('YYYY-MM-DD')).then(response => {
        console.log("Info Point: ", response.data.data)
        var info = response.data.data
        this.detailItemsCheckIn = info
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    deleteCoach(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/coaches/'.concat(event)).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    onSavePoint() {
      console.log(this.dataPoint)
      // validate
      if (this.dataPoint.adjust_point == 0) {
        this.$swal('Failed', 'Point must be greater than 0', 'warning')
        return
      } else if (this.dataPoint.reason == '') {
        this.$swal('Failed', 'Notes must be filled', 'warning')
        return
      } else if (this.dataPoint.adjust_type == 0) {
        this.$swal('Failed', 'Type must be selected', 'warning')
        return
      }

      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Save it!"
        })
        .then(result => {
          if (result.value) {
            this.loadingActive = true
            // console.log(this.dataPoint)

            // if dataPoint.adjust_type == 1 then add -total_point
            if (this.dataPoint.adjust_type == 2) {
              this.dataPoint.adjust_point = `-${this.dataPoint.adjust_point}`
            }

            const body = {
              trx_id: this.dataPoint.trx_id,
              member_id: Number(this.$route.query.id),
              amount: this.dataPoint.adjust_point,
              type: 'POINT',
              redeem_from: 'DATA_ENTRY',
              notes: this.dataPoint.reason,
              description: this.dataPoint.reason,
              sales_id: this.dataPoint.sales_id ? this.dataPoint.sales_id : 0
            }

            // console.log(body)

            axios.post('crm/v1/member_point/adjust_point', body).then(response => {
              this.loadingActive = false
              this.fetchData()
              this.$swal('Success', 'Point has been adjusted', 'success')
              this.$refs['adjust_member_point'].hide()
            }).catch((err) => {
              this.loadingActive = false
              this.$swal('Failed', 'Failed to adjust point', 'error')
              console.log(err)
            })
          }
        })
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/coaches/' + value
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      let url = 'mobile/v1/my_point/dashboard/point_history/' + this.$route.query.id + '?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData

      // if (this.branch_id != null)
      //   url = url + '&branch_id=' + this.branch_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('mobile/v1/my_point/total_points?member_id=' + this.$route.query.id).then(response => {
        this.totalPoint = response.data.data[0].total_points_idr
        this.totalEquals = response.data.data[0].equals_amount_idr
        this.pointsExpiredDate = response.data.data[0].points_expired_date
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/member_point_info/pt_session_running?member_id=' + this.$route.query.id + '&is_deleted=0').then(response => {
        // console.log('Running: ', response.data.data)
        this.itemsPtSessionRunning = response.data.data
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/member_point_info/pt_session_running_alpha?member_id=' + this.$route.query.id + '&is_deleted=0').then(response => {
        // console.log('Running: ', response.data.data)
        this.itemsPtSessionRunningAlpha = response.data.data
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/member_point_info/daily_checkin_detail?member_id=' + this.$route.query.id + '&date=' + moment().format('YYYY-MM-DD')).then(response => {
        // console.log("Info Point: ", response.data.data)
        var info = response.data.data
        this.detailItemsCheckIn = info
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })

      axios.get('crm/v1/member_point_info?member_id=' + this.$route.query.id).then(response => {
        var info = response.data.data
        this.itemsPtSession = info.pt_session
        this.itemsPtSessionAlpha = info.pt_session_alpha
        this.itemAutoPay = info.autopay
        this.itemCheckIn = info.check_in
        this.memberInfoData = info.member
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.dataPoint.trx_id = `DE-${moment().format('YYYYMMDD')}-${this.generateCode(4)}`

    this.fetchData()
    this.id_member = this.$route.query.id;

    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
  }
}
</script>

<style></style>
